import * as React from "react";

import Dialog from "@mui/material/Dialog";

import DialogContent from "@mui/material/DialogContent";

import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { useForm, Form } from "../form/useForm";
import Input from "../controls/Input";
import Select from "../../components/controls/Select";
import { Box, Typography } from "@mui/material";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import useStyles from "./editProductDialogStyle";
import { useTranslation } from "react-i18next";

import Button from "../controls/Button";

import globalStyles from "../../style/global.js";
import { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { useSelector, useDispatch } from "react-redux";

import CircularProgressBar from "../circularProgress/CircularProgress";

import ShowAlerts from "../alert/Alert";

import { editProductData } from "../../redux/reduser/editProduct";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
function EditProductDialog(props) {
    const classes = useStyles();
    const globalClasses = globalStyles();
  
    const { t } = useTranslation();
  
    const [file, setFile] = useState(null);
    const onDrop = useCallback((acceptedFiles) => {
      acceptedFiles.forEach((file) => {
        const reader = new FileReader();
  
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          // Do whatever you want with the file contents
          const binaryStr = reader.result;
          console.log(binaryStr);
          console.log(file);
          setFile(file);
          values.image=file.path;
        };
        reader.readAsArrayBuffer(file);
      });
    }, []);
    const { getRootProps, getInputProps } = useDropzone({
      onDrop,
      accept: ".png,.jpg,.jpeg",
    });
    const { response, loading, error, errorMsg } = useSelector(
      (state) => state.editProduct
    );
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
  
    const handleClose = () => {
      setOpen(false);
    };
  
    const initialFValues = {
      name: "",
  
      category: "",
      description: "",
      price: "",
  
      image: "",
    };
  
    const validate = (fieldValues = values) => {
      let temp = { ...errors };
      if ("name" in fieldValues)
        temp.name = fieldValues.name ? "" : t("required");
      if ("category" in fieldValues)
        temp.category = fieldValues.category ? "" : t("required");
      if ("description" in fieldValues)
        temp.description = fieldValues.description ? "" : t("required");
      if ("price" in fieldValues)
        temp.price = fieldValues.price ? "" : t("required");
      if ("image" in fieldValues)
        temp.image = fieldValues.image ? "" : t("required");
      setErrors({
        ...temp,
      });
  
      if (fieldValues == values) return Object.values(temp).every((x) => x == "");
    };
  
    const { values, setValues, errors, setErrors, handleInputChange, resetForm } =
      useForm(initialFValues, false, validate);
  
    const handleSubmit = (e) => {
      e.preventDefault();
  
      if (validate()) {
        dispatch(editProductData(values))
          .unwrap()
          .then(() => {
            if (!error) {
              resetForm();
              setOpen(true);
            } else {
              setOpen(true);
            }
          })
          .catch(() => {
            setOpen(true);
          });
      }
    };
  
    return (
      <div>
        <Dialog
          open={props.open}
          onClose={props.handleClose}
          TransitionComponent={Transition}
          keepMounted
          // fullWidth={true}
          maxWidth={"50%"}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogTitle> {props.title}</DialogTitle>
          <DialogContent>
            <div>
              <ShowAlerts
                open={open}
                handleClose={handleClose}
                type={error ? "error" : "success"}
                msg={error ? errorMsg : response.toString()}
              />
              {loading ? (
                <div className={globalClasses.center}>
                  <CircularProgressBar />
                </div>
              ) : null}
              <Form className={globalClasses.form}>
                <Box className={classes.box}>
                  <Input
                    name="name"
                    label={t("name")}
                    value={values.name}
                    className={globalClasses.filed}
                    onChange={handleInputChange}
                    error={errors.name}
                  />
                </Box>
                <Box className={classes.box}>
                  <Select
                    name="category"
                    label={t("category")}
                    className={globalClasses.filed}
                    value={values.category}
                    onChange={handleInputChange}
                    options={[t("software"), t("movies"), t("books")]}
                    error={errors.category}
                  />
                </Box>
                <Box className={classes.box}>
                  <Input
                    name="price"
                    label={t("price")}
                    type={"number"}
                    value={values.price}
                    className={globalClasses.filed}
                    onChange={handleInputChange}
                    error={errors.price}
                  />
                </Box>
                <Box className={classes.box}>
                  <Input
                    name="description"
                    label={t("description")}
                    value={values.description}
                    className={globalClasses.filed}
                    onChange={handleInputChange}
                    error={errors.description}
                  />
                </Box>
                {/* <Box className={classes.box}>
                  <Input
                    name="image"
                    placeHolder={t("image")}
                    type={"file"}
                    value={values.image}
                    className={globalClasses.filed}
                    onChange={handleInputChange}
                    error={errors.image}
                  />
                </Box> */}
                <Box className={globalClasses.imgBox}>
                  <Box className={classes.box} {...getRootProps()}>
                  {file == null ? <AddPhotoAlternateIcon
                      sx={{
                        fontSize: "40px",
                  
                      }}
                    />:null}
                    <input {...getInputProps()} />
                    {
                      <Typography variant="body2">
                        {file == null ? <>{!errors.image?t("dragFile"): t("required")} </> : file.path}
                      </Typography>
                    }
                  </Box>
                </Box>
                <Box className={classes.box}>
                  <p></p>
                </Box>
  
                <Box>
                  <Button
                    className={globalClasses.btn}
                    text={props.close}
                    className={globalClasses.btn}
                    onClick={props.handleClose}
                    color="primary"
                    disabled={loading}
                  />
                </Box>
                <Box>
                  <Button
                    className={globalClasses.btn}
                    variant="contained"
                    color="primary"
                    disabled={loading}
                    onClick={handleSubmit}
                    type="submit"
                    text={t("update")}
                  />
                </Box>
              </Form>
            </div>
          </DialogContent>
          {/* <DialogActions>
                
                < Button text={props.close} 
                   className={globalClasses.btn} 
                onClick={props.handleClose}/>
              </DialogActions> */}
        </Dialog>
      </div>
    );
  }

export default EditProductDialog
